// extracted by mini-css-extract-plugin
export var hiddenLabel = "LanguageSwitch-module--hiddenLabel--389c2";
export var modal = "LanguageSwitch-module--modal--cbe92";
export var overlay = "LanguageSwitch-module--overlay--afb3c";